<script lang="ts" setup>
import type { DictKey, } from "@/apis/dict"
import type { ApiConfig, ApiSelectInstance, ApiSelectProps, } from "@/components/ApiSelect"
import type { DictState, } from "@/hooks/useDict.ts"
import { omit, } from "lodash-es"
import { basePropsKeys, } from "@/components/ApiSelect"
import { useDict, } from "@/hooks/useDict.ts"

defineOptions({
  name: "DictSelect",
},)

const props = withDefaults(defineProps<Props>(), {
  params: () => ({}),
  immediate: true,
  cacheData: true,
  persistent: true,
},)
type Props = ApiSelectProps & {
  dictCode: DictKey
}

const attrs: Record<string, unknown> = useAttrs()

const { fetchDictList, } = useDict()

const apiConfig: ApiConfig<undefined, DictState> = {
  api: fetchDictList,
  config: {
    label: "name",
    value: "code",
    disabled: "disabled",
  },
}

const bindProps = computed<ApiSelectProps>(() => {
  const omitProps = omit(props, [...basePropsKeys, "dictCode",],)
  return {
    ...attrs,
    ...omitProps,
    apiConfig,
    cacheKey: props.dictCode,
    cacheData: true,
    afterFetch,
  }
},)

function afterFetch(data?: DictState,) {
  const key = props.dictCode
  const currentData = data?.[`${key}List`]
  return currentData || []
}

const apiSelectRef = ref<ApiSelectInstance>()

const componentRef = computed(() => {
  return apiSelectRef.value?.componentRef
},)

defineExpose({
  componentRef,
},)
</script>

<template>
  <ApiSelect ref="apiSelectRef" v-bind="bindProps" />
</template>

<style lang="scss" scoped>

</style>
